import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { getSearchFilterOptions } from 'app/services/SharedServices/SharedServices';
import { orderBy } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsEditMod, selectIsUndoModal } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { findKeyBaseOnValue, formatTypeAheadOptions } from '../../ModificationsUtils';

export const Payer = () => {
  const { control, getValues, setValue, register, setError, clearErrors } = useFormContext();
  const { t } = useTranslation();
  const isModEdit = useSelector(selectIsEditMod);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const namePayer = 'payer';
  register('payerId');
  const dispatch = useDispatch();
  const isUndoModal = useSelector(selectIsUndoModal);
  const [payerOptions, setPayerOptions] = useState([]);

  const getPayerDropDown = async () => {
    const options = await getSearchFilterOptions('payer');

    if (options?.length > 0) {
      const newOptions = formatTypeAheadOptions(options);
      setPayerOptions(orderBy(newOptions, 'id', 'asc'));

      if (getValues(namePayer)) {
        const selectedOption = findKeyBaseOnValue(newOptions, getValues(namePayer));

        setValue('payerId', selectedOption?.id);
        clearErrors(namePayer);
      } else {
        setError(namePayer, {});
      }
      if (isUndoModal) {
        dispatch(placementModsAction.setIsUndoModal(false));
      }
    }
  };

  const getPayerId = (value: string) => {
    const selectedOption = findKeyBaseOnValue(payerOptions, value);
    return selectedOption?.id;
  };

  const onSelectionChange = (value?: string) => {
    setValue(namePayer, value);
    setValue('payerId', getPayerId(value));
    if (value) {
      clearErrors(namePayer);
    }
  };

  useEffect(() => {
    getPayerDropDown();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUndoModal]);

  return (
    <Controller
      control={control}
      name={namePayer}
      rules={{
        required: true,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <FormInputDropdown
          useMenuItem={true}
          name={namePayer}
          label={t('placement.placementMods.payer')}
          standard={true}
          options={payerOptions}
          handleChange={e => {
            onSelectionChange(e.target.value);
            onChange(e.target.value);
          }}
          inputValue={getValues(namePayer) ?? ''}
          readOnly={!isModEdit}
          disabled={isSaveModApiCalling}
          {...rest}
        ></FormInputDropdown>
      )}
    />
  );
};
